<script lang="ts">

    export let size = 30;
    export let color = '#fff';

</script>

<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size * (27 / 30)} viewBox="0 0 30 27">
    <g transform="translate(-3 -3)">
        <path fill={color} d="M22.8,18A4.8,4.8,0,1,1,18,13.2,4.8,4.8,0,0,1,22.8,18Z"/>
        <path fill={color} d="M13.5,3,10.755,6H6A3.009,3.009,0,0,0,3,9V27a3.009,3.009,0,0,0,3,3H30a3.009,3.009,0,0,0,3-3V9a3.009,3.009,0,0,0-3-3H25.245L22.5,3ZM18,25.5A7.5,7.5,0,1,1,25.5,18,7.5,7.5,0,0,1,18,25.5Z"/>
    </g>
</svg>
  